'use client'
import { Heading as ChakraHeading } from '@chakra-ui/react'
import { forwardRef, LegacyRef } from 'react'

import { HeadingProps } from './Heading.types'

export default forwardRef(function Heading(
  props: HeadingProps,
  ref: LegacyRef<HTMLParagraphElement>
) {
  return <ChakraHeading {...props} ref={ref} translate="no" />
})
